import { useTheme } from "@/context/ThemeContext";

const LOGO_DAY = "https://customer-assets.emergentagent.com/job_smart-prep-board/artifacts/wgj08sns_PrepMasters%20New%20Logo%20Day.png";
const LOGO_NIGHT = "https://customer-assets.emergentagent.com/job_smart-prep-board/artifacts/c8fzp7x9_PrepMasters%20New%20Logo%20Night.png";

/**
 * BrandLogo — renders the PrepMaster wordmark logo, automatically swapping
 * between day-mode (white bg) and night-mode (black bg) variants based on
 * the active theme.
 *
 * Props:
 *  - size: "sm" (h-7) | "md" (h-9) | "lg" (h-10)
 *  - className: optional extra classes (e.g., margin)
 */
export default function BrandLogo({ size = "md", className = "" }) {
  const { theme } = useTheme();
  const src = theme === "dark" ? LOGO_NIGHT : LOGO_DAY;
  // Sizes are 75% of the original h-7/h-9/h-10 footprint (logo rebrand 2026).
  const sizeClass = size === "sm" ? "h-[1.3125rem]" : size === "lg" ? "h-[1.875rem]" : "h-[1.6875rem]";
  return (
    <img
      src={src}
      alt="PrepMaster"
      className={`${sizeClass} w-auto ${className}`}
      data-testid="brand-logo"
    />
  );
}
